import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { MonthlyCashFlow } from '../model/accounting.model';
import { userSignOutSuccess } from '../../authentication/store/authentication.action';
import { dumpStore } from '../../core/store/app.actions';
import { getMonthlyCashFlowStateSuccess } from './monthly-cashflow.action';

export default interface MonthlyCashflowState extends EntityState<MonthlyCashFlow> {
}

export function selectId(a: MonthlyCashFlow): string {
  return a.yearMonth;
}

export function sortComparer(a: MonthlyCashFlow, b: MonthlyCashFlow): number {
  return a.yearMonth.localeCompare(b.yearMonth);
}

export const adapter = createEntityAdapter<MonthlyCashFlow>({
  selectId,
  sortComparer,
});

export const initialState: MonthlyCashflowState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(dumpStore, (state): MonthlyCashflowState => {
    console.log(JSON.stringify(state));
    return state;
  }),
  on(userSignOutSuccess, (state): MonthlyCashflowState => adapter.removeAll(state)),
  on(getMonthlyCashFlowStateSuccess, (state, { monthlyCashFlowState }): MonthlyCashflowState =>
    adapter.upsertMany(monthlyCashFlowState, state)),
);

// get the selectors
const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

// select the array of monthly cashflow ids (yearmonths)
export const selectMonthlyCashFlowYearMonths = selectIds;

// select the dictionary of monthly cashflow
export const selectMonthlyCashFlowPerYearMonth = selectEntities;

// select the array of monthly cashflow
export const selectAllMonthlyCashFlow = selectAll;

// select the total monthly cashflow count
export const selectMonthlyCashFlowTotal = selectTotal;
